import {BlueRibbonConnection} from './blue_ribbon_connection';
import {
    FullGameDetails,
    GameObject,
    PlayerOptResponse,
    ComplexMatchDetails,
} from './blue_ribbon_api_interfaces';
import {IBlueRibbonConnection} from './blue_ribbon_connection_interface';

export class BlueRibbonConnectionProxy implements IBlueRibbonConnection {
    constructor() {
        this._waitForInnerConnectionPromise = new Promise<void>((resolve, reject) => {
            this._resolveWaitPromise = resolve;
            this._rejectWaitPromise = reject;
        });
    }

    dispose(): Promise<void> {
        if(this._innerConnection) {
            return this._innerConnection.dispose().then(() => this._resolveWaitPromise());
        } else {
            return Promise.resolve().then(() => this._resolveWaitPromise());
        }
    }

    private _innerConnection: BlueRibbonConnection = null;

    public setInnerConnection(innerConnection: BlueRibbonConnection): void {
        this._innerConnection = innerConnection;
        this._innerConnection.waitForConnect()
            .then(() => {
                this._resolveWaitPromise();
            })
            .catch(err => {
                this._rejectWaitPromise(err);
            });
    }

    get isConnected() {
        if(this._innerConnection) {
            return this._innerConnection.isConnected;
        } else {
            return false;
        }
    }

    private _resolveWaitPromise: Function;
    private _rejectWaitPromise: Function;
    private readonly _waitForInnerConnectionPromise: Promise<void>;

    waitForConnect() {
        return this._waitForInnerConnectionPromise;
    }

    getOperatorGamesMatchDetails(): Promise<ComplexMatchDetails[]> {
        return this._waitForInnerConnectionPromise.then(() => {
            return this._innerConnection.getOperatorGamesMatchDetails();
        });
    }
    isPlayerOptInToJackpotGame(game: GameObject): Promise<PlayerOptResponse> {
        return this._waitForInnerConnectionPromise.then(() => {
            return this._innerConnection.isPlayerOptInToJackpotGame(game);
        });
    }

    getGameDetailsByGameIds(gameIds: GameObject[]): Promise<FullGameDetails[]> {
        return this._waitForInnerConnectionPromise.then(() => {
            return this._innerConnection.getGameDetailsByGameIds(gameIds);
        });
    }

    startOneJackpotFeed(jackpotId: string): Promise<void> {
        return this._waitForInnerConnectionPromise.then(() => {
            return this._innerConnection.startOneJackpotFeed(jackpotId);
        });
    }

    stopOneJackpotFeed(jackpotId: string): Promise<any> {
        return this._waitForInnerConnectionPromise.then(() => {
            return this._innerConnection.stopOneJackpotFeed(jackpotId);
        });
    }
}